import { useQuery } from '@tanstack/react-query';

import { makeAuthenticatedGetRequest } from '../../../services/axios';
import { getFollowedProjectsCount } from '../../../services/axios/endpoints';
import { queryKeys } from '../../../services/react-query/queryKeys';

export default function useFetchFollowedProjectsCount() {
  return useQuery<number>({
    queryKey: queryKeys.navbar.followedProjectsCount(),
    queryFn: async () => {
      const response = await makeAuthenticatedGetRequest(getFollowedProjectsCount);
      return response?.data?.count ?? 0;
    },
  });
}
